import React from "react";
import classes from "../memory.module.css";
import Image from "../../../components/Image/Image";
import { SEARCH_PROSPECTS_IMAGE } from "../../../utils/constants/assets";
import { GREY } from "../../../utils/constants/colors";
import { fontWeight } from "../../../utils/constants/UI";
import TypographyInline from "../../../components/Typography/TypographyInline";

const MemoryEmptyState = ({ data }) => {
  return (
    <div className={classes.emptyStateContainer}>
      <Image
        src={SEARCH_PROSPECTS_IMAGE}
        alt="No Memory Found"
        className={classes.emptyStateImage}
      />
      <div className={classes.emptyStateText}>
        <TypographyInline
          label={data.create}
          size="xl"
          fontWeight={fontWeight.BOLD}
          color={GREY.PRIMARY}
        />
        <TypographyInline
          label={data.content}
          size="md"
          fontWeight={fontWeight.REGULAR}
          color={GREY.SECONDARY}
        />
        <div className={classes.emptyStateBody}>
          {data?.body?.map((item, index) => (
            <TypographyInline
              key={index}
              label={item}
              size="sm"
              fontWeight={fontWeight.REGULAR}
              color={GREY.TERTIARY}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MemoryEmptyState;
